class Header {
	constructor(config) {
		this.config = Object.assign({
			scope: '#mobile-menu',
			openMenuButton: '#open-menu',
			closeMenuButton: '#close-menu',
			menuGroup: '.mobile-menu-item.has-children > .item-title',
			menuBack: '.mobile-menu-item.menu-back > .back-button',
		}, config);

		this.$scope = $(this.config.scope);

		this.init();
	}

	init() {
		this.setHeight();
		this.addEventListeners();
	}

	addEventListeners() {
		$(this.config.openMenuButton).on('click', this.openMenu.bind(this));
		$(this.config.closeMenuButton).on('click', this.closeMenu.bind(this));
		this.$scope.on('click', this.config.menuGroup, this.openSubMenu.bind(this));
		this.$scope.on('click', this.config.menuBack, this.closeSubMenu.bind(this));
		$(window).resize(this.setHeight.bind(this));
	}

	openMenu(e) {
		e.preventDefault();
		let $menu = this.$scope;
		$menu.addClass('open');
		$('body').addClass('no-scrolling');
	}

	closeMenu(e) {
		e.preventDefault();
		let $menu = this.$scope;
		$menu.removeClass('open');
		$menu.find('.children').removeClass('open');
		$('body').removeClass('no-scrolling');
	}

	openSubMenu(e) {
		e.preventDefault();
		$(e.currentTarget).closest('.mobile-menu-item').find('> .children').addClass('open');
	}

	closeSubMenu(e) {
		e.preventDefault();
		$(e.currentTarget).closest('.children').removeClass('open');
	}

	setHeight() {
		this.$scope.height(window.innerHeight);
	}
}

export default new Header;
